<template>
  <div class="testing-list-view">
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Report Validation
      <div
        slot="right"
        v-if="
          summaryData &&
            summaryData.customer_active &&
            summaryData.general_information &&
            summaryData.general_information.status
        "
      >
        <b-button
          type="is-success import-button"
          @click="buildReport"
          v-if="
            !isUserExternal &&
              !isViewOnlyUser &&
              summaryData.general_information.authorized_cam &&
              summaryData.general_information.status == 'Approved' &&
              summaryData.general_information.template_generation_status !=
                'In Progress'
          "
          >Generate Template</b-button
        >
        <b-button
          type="is-primary import-button"
          @click="reopenAction"
          v-if="
            !isUserExternal &&
              !isViewOnlyUser &&
              summaryData.general_information.authorized_cam &&
              summaryData.general_information.status == 'Approved'
          "
          >Reopen</b-button
        >
        <b-button type="is-normal import-button" @click="redirectToReport"
          >Cancel</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div
        class="level-left validation-collapse-header-text"
        @click="togglePanel"
      >
        <h3 class="import-type-name">General Information</h3>
        <b-icon :icon="isOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
      </div>
      <b-collapse class="validation-panel" animation="slide" :open="isOpen">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="account-circle"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Customer</div>
                  <div class="columns">
                    <span
                      class="no-padding"
                      v-if="summaryData && summaryData.general_information"
                    >
                      {{ summaryData.general_information.customer_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="flag"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Country</div>
                  <div class="columns">
                    <span
                      class="no-padding"
                      v-if="summaryData && summaryData.general_information"
                    >
                      {{ summaryData.general_information.country_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="domain"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Scheme</div>
                  <div class="columns">
                    <span
                      class="no-padding"
                      v-if="summaryData && summaryData.general_information"
                    >
                      {{ summaryData.general_information.scheme_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin"
                v-if="summaryData.general_information"
              >
                <div class="column">
                  <b-icon icon="sine-wave"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Stream</div>
                  <div class="columns">
                    <span
                      class="no-padding"
                      v-if="summaryData.general_information"
                    >
                      {{ summaryData.general_information.stream_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin"
                v-if="summaryData.general_information"
              >
                <div class="column">
                  <b-icon icon="tag"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Report Type
                  </div>
                  <div class="columns">
                    <span class="no-padding">
                      <router-link
                        v-if="!isExternalUser"
                        :to="
                          summaryData.sheet_config &&
                          summaryData.sheet_config.length > 0
                            ? {
                                path:
                                  '/rulesManager/tabularReportDefinition/' +
                                  summaryData.general_information
                                    .report_definition_id +
                                  '/definition-view',
                                params: {
                                  id:
                                    summaryData.general_information
                                      .report_definition_id
                                }
                              }
                            : {
                                path:
                                  '/rulesManager/reportDefinition/' +
                                  summaryData.general_information
                                    .report_definition_id +
                                  '/definition-view',
                                params: {
                                  id:
                                    summaryData.general_information
                                      .report_definition_id
                                }
                              }
                        "
                        >{{
                          summaryData.general_information.report_type
                        }}</router-link
                      >
                      <span v-else>
                        {{ summaryData.general_information.report_type }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin"
                v-if="summaryData.general_information"
              >
                <div class="column">
                  <b-icon icon="calendar-clock"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Period
                  </div>
                  <div class="columns">
                    <span v-if="summaryData" class="no-padding">
                      {{ summaryData.general_information.period }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="columns"
              v-if="summaryData && summaryData.general_information"
            >
              <div
                class="column columns no-margin is-2"
                v-if="
                  summaryData.general_information.template_documents &&
                    summaryData.general_information.template_documents.length >
                      0
                "
              >
                <div class="column">
                  <b-icon icon="notebook"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Generated Template
                  </div>
                  <div class="columns">
                    <a ref="#" @click.prevent="isFileListActive = true"
                      ><h4 class="no-padding validation-import-comments">
                        See Details
                      </h4></a
                    >
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin is-2"
                v-if="isUserAdminOrCAM"
              >
                <div class="column">
                  <b-icon icon="comment"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Add Comments
                  </div>
                  <div class="columns">
                    <a ref="#" @click.prevent="isCommentListActive = true"
                      ><h4 class="no-padding validation-import-comments">
                        See Comments
                      </h4></a
                    >
                    <b-icon
                      v-if="allCommentsList.length > 0"
                      icon="text-box-plus"
                      class="ml-2 primary is-small"
                    ></b-icon>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin is-2"
                v-if="summaryData.general_information"
              >
                <div class="column">
                  <b-icon icon="content-save"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Current Status
                  </div>
                  <div class="columns">
                    <span
                      v-if="summaryData && summaryData.general_information"
                      class="no-padding"
                    >
                      {{ summaryData.general_information.status }}
                      &nbsp;&nbsp;
                      <span
                        v-if="
                          summaryData.general_information.status ==
                            'Rejected by CAM' ||
                            summaryData.general_information.status ==
                              'Rejected by Customer'
                        "
                        class="additional-info"
                      >
                        <b-tooltip
                          type="is-primary"
                          :label="
                            summaryData.general_information
                              .comment_for_rejection
                          "
                          multilined
                        >
                          <i class="mdi mdi-information"></i>
                        </b-tooltip>
                      </span>
                      <span
                        v-if="
                          summaryData.general_information.status == 'Reopened'
                        "
                        class="additional-info"
                      >
                        <b-tooltip
                          type="is-primary"
                          :label="summaryData.general_information.reopen_reason"
                          multilined
                        >
                          <i class="mdi mdi-information"></i>
                        </b-tooltip>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin is-2"
                v-if="
                  summaryData.general_information &&
                    summaryData.general_information.approved_type
                "
              >
                <div class="column">
                  <b-icon icon="check-underline-circle"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    {{ summaryData.general_information.approved_type }}
                  </div>
                  <div class="columns">
                    <span class="no-padding">
                      {{ summaryData.general_information.approval_name }}
                    </span>
                  </div>
                  <div class="columns">
                    <span class="no-padding">
                      {{ summaryData.general_information.approval_timestamp }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <ReportManagerTabularSummary
      v-if="
        summaryData &&
          summaryData.sheet_config &&
          summaryData.sheet_config.length > 0
      "
      :data="summaryData"
      :sheet-config="summaryData.sheet_config"
      :status="summaryData.status"
      :comparableReportList="comparableReportList"
      :comparedSummaryData="comparedSummaryData"
      @upliftConfirm="applyUpliftConfirm"
      @revertUplift="revertUpliftConfirm"
      @loadCompareReportList="loadCompareReportList"
      @exportCompareReport="exportCompareReport"
      @loadCompareReport="loadCompareReport"
      @selectedTable="loadReportTable"
    />
    <report-manager-summary
      v-else
      :data="summaryData"
      :status="
        (summaryData.general_information &&
          summaryData.general_information.status) ||
          ''
      "
      :comparableReportList="comparableReportList"
      :comparedSummaryData="comparedSummaryData"
      @upliftConfirm="applyUpliftConfirm"
      @revertUplift="revertUpliftConfirm"
      @loadCompareReportList="loadCompareReportList"
      @exportCompareReport="exportCompareReport"
      @loadCompareReport="loadCompareReport"
    />
    <reported-item-list
      ref="reportedItemList"
      :data="summaryData"
      :categoriesDropdownValues="categoryDropDown"
      :rulesDropdownValue="ruleDropDown"
      :productGroupDropDown="productGroupDropDown"
      :productFamilyDropDown="productFamilyDropDown"
      :materialDetailDropDown="materialDetailDropDown"
      :materialGeneralDropdown="materialGeneralDropdown"
      :chemistryDropDown="chemistryDropDown"
      :packagingLevelDropDown="packagingLevelDropDown"
      :packagingTypeDropDown="packagingTypeDropDown"
      :isTest="false"
    />
    <section class="section is-main-section no-padding-top">
      <div
        class="columns"
        v-if="
          summaryData &&
            summaryData.customer_active &&
            summaryData.general_information &&
            ((summaryData.general_information.status ==
              'Sent for CAM Approval' &&
              summaryData.general_information.authorized_cam) ||
              summaryData.general_information.status ==
                'Sent for Customer Approval')
        "
      >
        <div
          class="column"
          v-if="
            !(
              !isUserExternal &&
              summaryData.general_information.status ==
                'Sent for Customer Approval'
            )
          "
        >
          <ul class="context-options-left">
            <li>
              <b-button
                slot="right"
                native-type="submit"
                type="is-success"
                @click="approveWorkflowStatus()"
              >
                Approve
              </b-button>
            </li>
            <li>
              <b-button
                slot="right"
                @click="showRejectWorkflowModel()"
                type="is-danger"
                class="deactivateBtn"
              >
                Reject
              </b-button>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="columns"
        v-if="
          summaryData &&
            summaryData.general_information &&
            summaryData.customer_active &&
            summaryData.general_information.status == 'Calculated' &&
            summaryData.general_information.authorized_cam
        "
      >
        <div class="column" v-if="!isUserExternal">
          <ul class="context-options-left">
            <li>
              <b-button
                slot="right"
                native-type="submit"
                type="is-success"
                @click="changeReportRunStatus('Sent for CAM Approval')"
              >
                Send for Approval
              </b-button>
            </li>
          </ul>
        </div>
      </div>
      <b-modal v-model="isRejectModalActive" has-modal-card>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title title-reject">
              You are rejecting the changes
            </p>
          </header>
          <section class="modal-card-body">
            <b-field label="Please describe the reasons">
              <b-input
                maxlength="500"
                type="textarea"
                v-model="comment"
              ></b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button
              label="Close"
              class="reject-modal-close-button"
              @click="isRejectModalActive = false"
            />
            <b-button
              label="Reject"
              type="is-danger"
              @click="rejectWorkflowStatus('reject')"
            />
          </footer>
        </div>
      </b-modal>
      <b-modal v-model="isReopenModalActive" has-modal-card>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title title-reject">Reason to Reopen</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Please describe the reasons">
              <b-input
                maxlength="500"
                type="textarea"
                v-model="reopen_reason"
              ></b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button
              label="Close"
              class="reject-modal-close-button"
              @click="isReopenModalActive = false"
            />
            <b-button
              label="Reopen"
              type="is-danger"
              @click="reopenWorkflowStatus('reopen')"
            />
          </footer>
        </div>
      </b-modal>
    </section>
    <b-modal v-model="isFileListActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Generated Template</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Template Generation Status">
            <span
              v-if="
                summaryData.general_information &&
                  summaryData.general_information.template_generation_status
              "
            >
              {{ summaryData.general_information.template_generation_status }}
            </span>
          </b-field>
          <b-field label="Generated By">
            <span
              v-if="
                summaryData.general_information &&
                  summaryData.general_information.template_generation_status &&
                  summaryData.general_information.template_documents.length > 0
              "
            >
              {{
                summaryData.general_information.template_documents[
                  summaryData.general_information.template_documents.length - 1
                ].updated_by
              }}
            </span>
          </b-field>
          <b-field
            label="Failure Details"
            v-if="
              summaryData.general_information &&
                summaryData.general_information.template_generation_status &&
                summaryData.general_information.template_generation_status ==
                  'Failed'
            "
          >
            {{ summaryData.general_information.template_failure_details }}
          </b-field>
          <b-field label="Documents">
            <div
              class="tags"
              v-if="
                summaryData.general_information &&
                  summaryData.general_information.template_documents &&
                  summaryData.general_information.template_documents.length > 0
              "
            >
              <span
                v-for="(file, index) in summaryData.general_information
                  .template_documents"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.template) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Cancel"
            class="is-normal"
            @click="isFileListActive = false"
          />
        </footer>
      </div>
    </b-modal>
    <b-modal v-model="isCommentListActive" has-modal-card>
      <div class="modal-card comment-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Comments</p>
        </header>
        <section class="modal-card-body">
          <div
            v-for="(comment, index) in allCommentsList"
            :key="index"
            class="columns column"
          >
            <article class="media">
              <figure class="media-left">
                <p class="image is-64x64 is-user-avatar">
                  <img :src="getImage(comment.created_by)" />
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong class="user-name">
                      {{ comment.created_by }}
                    </strong>
                    <br />
                    <span class="comment-media">
                      <small>Wrote on {{ comment.created_at }} </small>
                      <small
                        >(Edited {{ comment.updated_at }} by
                        {{ comment.updated_by }})
                      </small>
                    </span>
                    <a
                      @click="editComment(comment)"
                      v-if="
                        !comment.active &&
                          !isEditSaveComment &&
                          isUserAdminOrCAM
                      "
                      class="comment-edit-button"
                    >
                      edit</a
                    >
                    <br />
                    <span v-if="!comment.active">{{ comment.comment }}</span>
                    <b-input
                      type="textarea"
                      v-model="comment.comment"
                      maxlength="500"
                      v-if="comment.active && isUserAdminOrCAM"
                    ></b-input>
                    <br />
                    <b-button
                      @click="saveEditedComment(comment)"
                      type="is-primary"
                      class="is-small comment-edit-save"
                      v-if="
                        comment.active && isEditSaveComment && isUserAdminOrCAM
                      "
                    >
                      Save
                    </b-button>
                  </p>
                </div>
              </div>
            </article>
          </div>
          <article
            class="media add-new-comment-section"
            v-if="isUserAdminOrCAM"
          >
            <div class="media-content">
              <div class="field">
                <p class="control">
                  <b-input
                    type="textarea"
                    v-model="addComment"
                    maxlength="500"
                    placeholder="Add a comment..."
                  ></b-input>
                </p>
              </div>
              <div class="buttons">
                <b-button
                  @click="saveComment"
                  type="is-primary save-comment-button"
                  expanded
                  icon-left="content-save-outline"
                >
                  Save
                </b-button>
              </div>
            </div>
          </article>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Close"
            class="reject-modal-close-button"
            @click="closeCommentList"
          />
        </footer>
      </div>
    </b-modal>
    <b-loading
      :is-full-page="false"
      v-model="isSummaryLoading"
      :can-cancel="false"
    ></b-loading>
    <div class="disclaimer-footer">
      <span
        >*Fees displayed may differ from the final invoices issued by the
        respective schemes.</span
      >
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import ReportManagerService from "../../services/ReportManagerDataService";
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
import UtilityMixin from "@/mixins/UtilityMixin";
import ReportManagerSummary from "@/components/ReportsManager/ReportManagerSummary.vue";
import ReportManagerTabularSummary from "@/components/ReportsManager/ReportManagerTabularSummary.vue";
import ReportedItemList from "@/components/ReportsManager/ReportedItemList.vue";
import ReportingTrackerService from "../../services/ReportingTrackerDataService";
export default {
  name: "ReportListView",
  components: {
    HeroBar,
    TitleBar,
    ReportManagerSummary,
    ReportManagerTabularSummary,
    ReportedItemList
  },
  mixins: [UtilityMixin],
  props: {
    isViewOnly: {
      type: Boolean,
      default: false
    },
    editObject: []
  },
  data() {
    return {
      tableObject: [],
      summaryData: { general_information: {} },
      addComment: null,
      isOpen: true,
      isSummaryLoading: false,
      viewRule: {},
      data: [],
      formData: [],
      isDataLoading: false,
      isViewModalActive: false,
      isRejectModalActive: false,
      isReopenModalActive: false,
      comment: "",
      reopen_reason: "",
      isFileListActive: false,
      isCommentListActive: false,
      categories: this.$route.params.categories,
      scopeData: this.$route.params.scopeData,
      RulesManagerService: new RulesManagerService(),
      ReportManagerService: new ReportManagerService(),
      ReportingTrackerService: new ReportingTrackerService(),
      categoryDropDown: [],
      ruleDropDown: [],
      productGroupDropDown: [],
      productFamilyDropDown: [],
      materialDetailDropDown: [],
      materialGeneralDropdown: [],
      chemistryDropDown: [],
      packagingLevelDropDown: [],
      packagingTypeDropDown: [],
      isLoading: false,
      comparableReportList: [],
      comparedSummaryData: {},
      allCommentsList: [],
      isEditSaveComment: false,
      selectedTable: null
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal"
    ]),
    titleStack() {
      return [
        { url: "#", name: "Report Manager" },
        { url: "/reportManager/reportsList", name: "Report List" },
        { url: "#", name: "Report List Visualization" }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    },
    isViewOnlyUser() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return true;
      }
      return false;
    },
    isExternalUser() {
      if (this.userGroups.includes(UserGroup.EXTERNAL_USER)) {
        return true;
      }
      return false;
    },
    isUserAdminOrCAM() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER) ||
        this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE)
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.fetchConfigDropdown();
    this.getReportRunSummaryById();
    if (this.isUserAdminOrCAM) {
      this.fetchAllComments();
    }
    document.addEventListener("scroll", this.handleClickOutsideDropdown);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.handleClickOutsideDropdown);
  },

  methods: {
    handleClickOutsideDropdown(event) {
      // Replace '.multiselect' with your dropdown's class or ref as needed
      const dropdowns = document.querySelectorAll(".multiselect");
      let clickedInside = false;
      dropdowns.forEach(dropdown => {
        if (dropdown.contains(event.target)) {
          clickedInside = true;
        }
      });
      if (!clickedInside) {
        // Close all dropdowns
        dropdowns.forEach(dropdown => {
          if (
            dropdown.__vue__ &&
            typeof dropdown.__vue__.deactivate === "function"
          ) {
            dropdown.__vue__.deactivate();
          }
        });
      }
    },
    getImage(userName) {
      return `https://api.dicebear.com/7.x/initials/svg?seed=${userName}`;
    },
    closeCommentList() {
      this.isCommentListActive = false;
      this.isEditSaveComment = false;
    },
    saveEditedComment(comment) {
      if (comment.comment == "" || comment.comment == null) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please add a comment..."
        });
      } else {
        this.ReportManagerService.editComment(
          comment,
          this.$route.params.id
        ).subscribe(() => {
          this.fetchAllComments();
          this.isEditSaveComment = false;
        }, this.handleApiError);
      }
    },
    editComment(comment) {
      const index = this.allCommentsList.indexOf(comment);
      this.allCommentsList[index].active = true;
      this.isEditSaveComment = true;
    },
    saveComment() {
      if (this.addComment == "" || this.addComment == null) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please add a comment..."
        });
      } else {
        this.ReportManagerService.saveComment(
          this.addComment,
          this.$route.params.id
        ).subscribe(() => {
          this.fetchAllComments();
          this.addComment = "";
        }, this.handleApiError);
      }
    },
    fetchAllComments() {
      this.ReportManagerService.fetchAllComments(
        this.$route.params.id
      ).subscribe(response => {
        this.allCommentsList = response;
      }, this.handleApiError);
    },
    cancelComment() {
      this.addComment = "";
    },
    loadCompareReportList() {
      this.ReportManagerService.loadComparableReportList(
        this.$route.params.id,
        "report_run"
      ).subscribe(response => {
        this.comparableReportList = response;
      }, this.handleApiError);
    },
    loadCompareReport(id) {
      this.ReportManagerService.getReportRunCompareData(
        id,
        this.$route.params.id,
        "report_run"
      ).subscribe(res => {
        this.comparedSummaryData = res;
        this.isLoading = false;
      }, this.handleApiError);
    },
    exportCompareReport(id) {
      try {
        this.ReportManagerService.exportCompareReport(
          this.$route.params.id,
          id,
          "report_run"
        );
      } catch (e) {
        this.handleApiError;
      }
    },
    approveWorkflowStatus() {
      this.$buefy.dialog.confirm({
        canCancel: true,
        title: "",
        message: "Are you sure you want to approve?",
        cancelText: "No",
        confirmText: "Yes",
        size: "is-medium",
        onConfirm: () => this.changeReportRunStatus("approved")
      });
    },
    showRejectWorkflowModel() {
      this.isRejectModalActive = true;
    },
    reopenAction() {
      this.isReopenModalActive = true;
    },
    fetchConfigDropdown() {
      this.ReportManagerService.getConfigDropdown(
        this.$route.params.id
      ).subscribe(
        response => {
          this.categoryDropDown = response.report_categories;
          this.productFamilyDropDown = this.prepareDropDownArray(
            response.product_family
          );
          this.productGroupDropDown = this.prepareDropDownArray(
            response.product_group
          );
          this.materialDetailDropDown = this.prepareDropDownArray(
            response.material_detail
          );
          this.materialGeneralDropdown = this.prepareDropDownArray(
            response.material_general
          );
          this.chemistryDropDown = this.prepareDropDownArray(
            response.chemistry
          );
          this.packagingLevelDropDown = this.prepareDropDownArray(
            response.packaging_level
          );
          this.packagingTypeDropDown = this.prepareDropDownArray(
            response.packaging_type
          );
          this.ruleDropDown = response.rules;
        },
        e => {
          this.isLoading = false;
          console.log(e);
        }
      );
    },
    prepareDropDownArray(value) {
      const result = [];
      if (value && Array.isArray(value)) {
        value.forEach(element => {
          const obj = {};
          obj["name"] = element;
          result.push(obj);
        });
      }
      return result;
    },
    buildReport() {
      this.isLoading = true;
      if (
        this.summaryData &&
        this.summaryData.general_information &&
        this.summaryData.general_information.template_documents &&
        this.summaryData.general_information.template_documents.length > 0
      ) {
        this.$buefy.dialog.confirm({
          title: "Re-generate Template",
          message:
            "Do you want to re-generate template ? It will erase existing generated template",
          confirmText: "Confirm",
          type: "is-info",
          onConfirm: () => this.downloadTemplateFile()
        });
      } else {
        this.downloadTemplateFile();
      }
      //this.isLoading = false;
    },
    downloadTemplateFile() {
      try {
        this.ReportManagerService.generateBuildReport(
          this.$route.params.id
        ).subscribe(
          response => {
            this.isLoading = false;
            if (response.success) {
              this.$buefy.toast.open({
                message: response.success,
                type: "is-success"
              });
            } else {
              this.$buefy.toast.open({
                message: response.failure,
                type: "is-danger"
              });
            }
          },
          e => {
            this.isLoading = false;
            console.log(e);
          }
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message
        });
        this.isLoading = false;
      }
    },
    reopenWorkflowStatus() {
      if (this.reopen_reason.trim().length === 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please leave a comment for reopening.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return false;
      }

      this.$buefy.dialog.confirm({
        canCancel: true,
        title: "",
        message: "Are you sure you want to reopen?",
        cancelText: "No",
        confirmText: "Yes",
        size: "is-medium",
        onConfirm: () => this.changeReportReopenStatus()
      });
    },
    changeReportReopenStatus() {
      this.isReopenModalActive = false;
      this.ReportManagerService.changeReportReopenStatus(
        this.$route.params.id,
        this.reopen_reason
      ).subscribe(() => {
        this.redirectToReport();
      }, this.handleApiError);
    },
    rejectWorkflowStatus() {
      if (this.comment.trim().length === 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please leave a comment for the rejection.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return false;
      }

      this.$buefy.dialog.confirm({
        canCancel: true,
        title: "",
        message: "Are you sure you want to reject?",
        cancelText: "No",
        confirmText: "Yes",
        size: "is-medium",
        onConfirm: () => this.changeReportRunStatus("reject")
      });
    },
    changeReportRunStatus(status) {
      const hasWeight = this.summaryData.category_list.filter(
        item => item.main_category == "PD without Weight"
      );
      if (
        hasWeight.total_weight > 0 &&
        this.summaryData.uplift_applied != null
      ) {
        this.$buefy.dialog.alert({
          title: "Information",
          message:
            "This report includes products marked as PD without weight Categorized. Would you like to apply a weight uplift to them?",
          type: "is-info",
          ariaRole: "alertdialog",
          cancelText: "Continue Anyway",
          confirmText: "OK",
          onConfirm: () => {
            this.isRejectModalActive = false;
          },
          onCancel: () => {
            this.confirmStatusChange(status);
          },
          ariaModal: true
        });
        return false;
      } else {
        this.confirmStatusChange(status);
      }
    },
    confirmStatusChange(status) {
      this.isRejectModalActive = false;
      this.ReportManagerService.changeReportRunStatus(
        this.$route.params.id,
        status,
        this.comment
      ).subscribe(() => {
        this.$buefy.toast.open({
          message: "Report status updated successfully.",
          type: "is-success"
        });
        this.redirectToReport();
      }, this.handleApiError);
    },
    togglePanel() {
      return (this.isOpen = !this.isOpen);
    },
    getReportRunSummaryById() {
      this.isSummaryLoading = true;
      this.ReportManagerService.getReportRunSummaryById(
        this.$route.params.id
      ).subscribe(
        response => {
          this.summaryData = response || {};
          this.summaryData.general_information =
            this.summaryData.general_information || {};
          // Keep loading until summaryData is populated
          if (this.summaryData && Object.keys(this.summaryData).length > 0) {
            this.$nextTick(() => {
              this.isSummaryLoading = false;
            });
          }
        },
        error => {
          this.isSummaryLoading = false;
          this.handleApiError(error);
        }
      );
    },

    redirectToReport() {
      this.summaryData = [];
      this.$router.push({
        name: "reportManager.reportsList"
      });
    },

    getFileName(file) {
      return file.substring(file.lastIndexOf("/") + 1).replaceAll("%20", " ");
    },

    downloadContent(file) {
      try {
        this.ReportManagerService.downloadTemplateFile(
          this.$route.params.id,
          this.getFileName(file.template)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },

    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.isSummaryLoading = false;
      this.isLoading = false;
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.redirectToReport()
      });
    },
    handleJsonApiError(reason) {
      const errorMessage = reason.response.data["message"];
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
        // onConfirm: () => this.$router.go(),
      });
    },

    applyUpliftConfirm(data) {
      data["run_type"] = "Report Run";
      data["run_id"] = this.$route.params.id;
      data["stream_id"] = this.summaryData.general_information.stream_id;
      this.ReportManagerService.applyUplift(data).subscribe(() => {
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Uplift applied successfully",
          onConfirm: () => this.getReportRunSummaryById()
        });
      }, this.handleJsonApiError);
    },
    revertUpliftConfirm() {
      this.ReportManagerService.revertUplift(
        "Report Run",
        this.$route.params.id,
        this.summaryData.general_information.stream_id
      ).subscribe(() => {
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Uplift reverted successfully",
          onConfirm: () => this.getReportRunSummaryById()
        });
      }, this.handleJsonApiError);
    },
    loadReportTable(tableInfo) {
      this.selectedTable = tableInfo;
      if (this.$refs.reportedItemList) {
        // Handle both old string format and new object format
        if (typeof tableInfo === "object" && tableInfo.tableName) {
          this.$refs.reportedItemList.loadTable(
            tableInfo.tableName,
            tableInfo.sheetName
          );
        } else {
          // Backward compatibility for string format
          this.$refs.reportedItemList.loadTable(tableInfo, "");
        }
      }
    }
  }
};
</script>
